export default __webpack_public_path__ + "static/media/so.697398c9.png";